module.exports = __webpack_public_path__ + "img/Engagement plan-Stakeholder engagement.e638406e.svg";